import { IIcon } from '@ads/front-ds'
import { Variant } from './interfaces'

const COLOR_BY_VARIANT: Record<Variant, IIcon['color']> = {
  [Variant.WARNING]: 'warning50',
  [Variant.ERROR]: 'alert50',
  [Variant.INFO]: 'primary50',
}

export const getColor = (variant: Variant): IIcon['color'] =>
  COLOR_BY_VARIANT[variant]
